import { Map, List } from 'immutable'
import { browserHistory } from 'react-router'

import organisationAdminService from '../services/organisation-admin'
import { setError } from './error'

const FETCH_ACCOUNTS = 'organisation-admin/FETCH_ACCOUNTS'
const FETCH_USAGE_LOG_SUMMARY = 'organisation-admin/FETCH_USAGE_LOG_SUMMARY'
const DELETE_ACCOUNT = 'organisation-admin/DELETE_ACCOUNT'

const defaultState = Map({
  accounts: List(),
  usageLog: List(),
  deletedAccountIds: List()
})

export default function(state = defaultState, action = undefined) {
  switch (action.type) {
    case FETCH_ACCOUNTS:
      return state.update('accounts', accounts => List(action.payload.accounts))

    case FETCH_USAGE_LOG_SUMMARY:
      return state.update('usageLog', summaries => List(action.payload.summary))

    case DELETE_ACCOUNT:
      return state.update('deletedAccountIds', deletedAccountIds =>
        deletedAccountIds.push(action.payload.accountId)
      )

    default:
      return state
  }
}

export function addAccount(email, givenName, familyName, organisationId, language, roles) {
  return function d(dispatch) {
    organisationAdminService
      .addAccount(email, givenName, familyName, organisationId, language, roles)
      .then(() => browserHistory.push('/management'))
      .catch(e => {
        if (e.response.data.error == 'duplicate_email') {
          setError('duplicate_email')(dispatch)
        }
      })
  }
}

export function fetchAccounts(organisationId) {
  return function d(dispatch) {
    organisationAdminService
      .getAccounts(organisationId)
      .then(data => dispatch({ type: FETCH_ACCOUNTS, payload: data.data }))
  }
}

export function deleteAccount(accountId) {
  return dispatch => {
    organisationAdminService
      .deleteAccount(accountId)
      .then(response => dispatch({ type: DELETE_ACCOUNT, payload: { accountId } }))
  }
}

export function fetchUsageSummary(organisationId, year, month) {
  return function d(dispatch) {
    if (!year || !month) {
      return dispatch({ type: FETCH_USAGE_LOG_SUMMARY, payload: [] })
    }

    organisationAdminService
      .getUsageLogSummary(organisationId, year, month)
      .then(data => dispatch({ type: FETCH_USAGE_LOG_SUMMARY, payload: data.data }))
  }
}

export function promoteToAdmin(organisationId, accountId) {
  return function d(dispatch) {
    organisationAdminService
      .promoteToAdmin(organisationId, accountId)
      .then(data => fetchAccounts(organisationId)(dispatch))
  }
}



// WEBPACK FOOTER //
// ./src/ducks/organisation-admin.js